export default "__VITE_ASSET__CW5ndlzj__"